export default "__VITE_ASSET__BgN07suF__"